export default __webpack_public_path__ + "static/mobile-screen-0cac49b542a5e0e535ecc8457c6acbd1.png";